
import template from '../../../templates/checkout-flow/summary.directive.tpl.html';

import app from '../../App';

export function summaryDirective (TaxRatesService,PromoCodeService,PricingHelper,CurrencyHelper,SignUpPaidService) {
    
    'ngInject';

    return {
        restrict: 'E',
        scope: {
            data: '=',
            laststep: '=',
            selectedshippingrate: '=',
            purchasedisabled: '='
        },
        templateUrl: template,
        link: ( scope, element, attrs ) => {
            scope.CurrencyHelper=CurrencyHelper;
            scope.currentPromoCode='';
            scope.currentPlan=scope.data.pricingParams.plan[0].toUpperCase() + scope.data.pricingParams.plan.substring(1);
            scope.showPromoError=false;
            scope.promoErrorMessage='';
            scope.promoCodeThatMakeError='';
            scope.showSignUpError=false;
            scope.signUpErrorMessage='';
            scope.loading=false;
            scope.$watch('data', (newValue,oldValue) => {
                if(scope.data.pricingParams.devices==0){
                    scope.selectedshippingrate={Amount:0};
                }
                scope.updateData();
            },true);
            scope.$watch('currentPromoCode', (newValue) => {
                if(newValue!=scope.promoCodeThatMakeError){
                    scope.showPromoError=false;
                }
            });
            scope.updateData= ()=>{
                scope.currentPlan=scope.data.pricingParams.plan[0].toUpperCase() + scope.data.pricingParams.plan.substring(1);
                scope.licensePrice=PricingHelper.getTotalLicense(scope.data.pricingParams.plan,scope.data.pricingParams.displays);
                scope.devicesPrice=PricingHelper.getTotalDevices(scope.data.pricingParams.displays,scope.data.pricingParams.devices)-PricingHelper.getTotalDevicesDiscount(scope.data.pricingParams.plan,scope.data.pricingParams.displays,scope.data.pricingParams.devices);
                scope.totalPrice=scope.licensePrice+scope.devicesPrice;
                scope.data.validatedPromocodes.forEach(
                    (promo)=>{
                        scope.totalPrice-=scope.applyDiscount(promo);
                    }
                );
                scope.tax=scope.devicesPrice*scope.calculateTaxRate().TaxRate;

                scope.totalPriceWithTax=scope.totalPrice+scope.tax+scope.selectedshippingrate.Amount;
            };
            scope.applyDiscount = (promo) => {
                if(promo.PromoCodeType=="Dollars"){
                    return promo.DollarsOff;
                }else{
                    if(promo.AppliesToDevices) {
                        return scope.licensePrice*promo.PctOff+scope.licensePrice*promo.PctOff;
                    }else {
                        return scope.licensePrice*promo.PctOff;
                    }
                }
            };
            scope.applyPromoCode= (value)=> {
                PromoCodeService.getPromoCodeDiscount(value?value:scope.currentPromoCode,scope.data.pricingParams.displays).then(
                    (response) => {
                        if(response.data.Success) {
                            let promoCode=response.data.Result.PromoCode;
                            console.log(response.data);
                            // if(scope.data.validatedPromocodes.slice(0).filter((value)=>{value});
                            let newArray=[];
                            scope.data.validatedPromocodes.forEach(
                                (item,index,arr)=>{
                                    if(item.PromoCodeType!=response.data.Result.PromoCodeType){
                                        newArray.push(arr[index]);
                                    }
                                }
                            );
                            newArray.push(response.data.Result);
                            scope.data.validatedPromocodes=newArray.splice(0);
                            newArray=undefined;

                            scope.currentPromoCode = '';
                        }else{
                            scope.promoCodeThatMakeError=scope.currentPromoCode.slice(0);
                            scope.showPromoError=true;
                            scope.promoErrorMessage=response.data.ErrorMessage;
                        }
                    },
                    (reject) => {
                        scope.currentPromoCode='';
                    }
                );
            };
            scope.calculateDevicesDiscount = () => {
                let devicesDiscount=0;
                scope.data.validatedPromocodes.forEach(
                    (promo)=> {
                        if (promo.AppliesToDevices == true && promo.PromoCodeType == "Dollars") {
                            devicesDiscount+= promo.DollarsOff;
                        }
                        if (promo.AppliesToDevices == true && promo.PromoCodeType != "Dollars") {
                            devicesDiscount+= scope.devicesPrice * promo.PctOff;
                        }
                    }
                );
                return devicesDiscount;
            };
            scope.calculateSubscriptionDiscount = () => {
                let subscriptionDiscount=0;
                scope.data.validatedPromocodes.forEach(
                    (promo)=> {
                        if (promo.AppliesToDevices == false && promo.PromoCodeType == "Dollars") {
                            subscriptionDiscount+= promo.DollarsOff;
                        }
                        if (promo.AppliesToDevices == false && promo.PromoCodeType != "Dollars") {
                            subscriptionDiscount+= scope.licensePrice * promo.PctOff;
                        }
                    }
                );
                return subscriptionDiscount;
            };
            scope.calculateShipping = () => {
                return scope.selectedshippingrate.Amount;
            };
            scope.calculatePromoCodes = () => {
                let promoCodes = [];
                scope.data.validatedPromocodes.forEach(
                    (promo)=>{
                        promoCodes.push(promo.PromoCode);
                    }
                );
                return promoCodes;
            };
            scope.calculateTaxRate= () => {
                if(scope.data.shippingAddressInfo.country=='US' && scope.data.shippingAddressInfo.state=='CA') {
                    return scope.data.taxRate;
                }else{
                    return {TaxRate:0};
                }
            };
            scope.showSignUpErrorModal = () =>{
                scope.showSignUpError=true;
            };
            scope.hideSignUpErrorModal = () =>{
                scope.showSignUpError=false;
            };
            scope.signUpPaidService = () => {
                scope.loading=true;
                scope.hideSignUpErrorModal();
                var deviceInfo = {Price:199.00,ProductTitle:"Enplug Device",Sku:"online"};
                SignUpPaidService.signup(scope.data.accountInfo,scope.data.shippingAddressInfo,scope.data.billingInfo,scope.data.billingAddressInfo,scope.data.pricingParams,deviceInfo,scope.data.token,scope.calculateTaxRate(),scope.calculateDevicesDiscount(),scope.calculateSubscriptionDiscount(),scope.calculateShipping(),scope.calculatePromoCodes(),scope.data.addressID,scope.selectedshippingrate.RateId).then(
                    (response) => {
                        if(response.data.Success){
                            scope.data.step=4;
                        }else{
                            console.log(response);
                            scope.showSignUpErrorModal();
                            scope.signUpErrorMessage=response.data.ErrorMessage;
                        }
                        scope.loading=false;
                    }
                )
            };
            if(scope.data.promocodes.length>scope.data.validatedPromocodes){
                scope.data.promocodes.forEach((item)=>{
                    scope.applyPromoCode(item);
                });
            }
        }
    };
};

app.directive( 'summaryDirective',summaryDirective );



// WEBPACK FOOTER //
// ./src/js/directives/checkout-flow/summary-directive.js